module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "ruleForm2",
    staticClass: "demo-ruleForm login-container",
    attrs: {
      "model": _vm.ruleForm2,
      "rules": _vm.rules2,
      "label-position": "left",
      "label-width": "150px"
    }
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Forget Password")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "username",
      "label": "UserName"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "UserName"
    },
    model: {
      value: (_vm.ruleForm2.username),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "username", $$v)
      },
      expression: "ruleForm2.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "email",
      "label": "Email"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "Password"
    },
    model: {
      value: (_vm.ruleForm2.email),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "email", $$v)
      },
      expression: "ruleForm2.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('a', {
    staticStyle: {
      "margin-bottom": "15px",
      "cursor": "pointer",
      "color": "#409eff"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('login')
      }
    }
  }, [_vm._v("Login")])]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("\n            Submit\n        ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-665f7a03"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/forgetPassword.vue
// module id = 834
// module chunks = 1